import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { Header } from '@carbon/react';
import { Close, Menu } from '@carbon/react/icons';
import { ContextBreadcrumb } from 'src/components/Layout/ContextBreadcrumb';
import { HeaderActions } from 'src/components/Layout/HeaderActions';
import { HeaderSearchTrigger } from 'src/components/Layout/HeaderSearchTrigger';
import { MainSideNav } from 'src/components/Layout/MainSideNav';
import { UserMenu } from 'src/components/Layout/UserMenu';
import { useAppStore } from 'src/states/app';

const MainHeader = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const inSettings = pathname.startsWith('/settings');
  const { sideNavExpanded, setSideNavExpanded } = useAppStore(
    (state) => ({ sideNavExpanded: state.sideNavExpanded, setSideNavExpanded: state.setSideNavExpanded }),
    shallow
  );
  const expanded = sideNavExpanded && !inSettings;

  return (
    <Header aria-label="Restavo">
      {/* The product mark and the navigation toggle share one control: the mark shows at
          rest and swaps to a hamburger on hover or keyboard focus. Both graphics are
          aria-hidden and the button keeps one stable accessible name, because the swap is
          decorative — a control whose announced name changed under the pointer would be
          worse for a screen reader, not better.

          This does remove the only in-app link to "/". The rail's Dashboard item still
          goes there, so home is reachable; it is no longer one click from the mark. */}
      <button
        type="button"
        id="header-nav-toggle"
        className="shell-nav-toggle"
        aria-label={t('header.toggleNavigation')}
        aria-expanded={expanded}
        onClick={() => setSideNavExpanded(!sideNavExpanded)}
      >
        <img className="shell-logo shell-nav-toggle__mark" src="/restavo.svg" alt="" aria-hidden />
        <Menu size={20} className="shell-nav-toggle__menu" aria-hidden />
        <Close size={24} className="shell-nav-toggle__close" aria-hidden />
      </button>
      <ContextBreadcrumb />
      <HeaderSearchTrigger />
      {/* Everything else in the flex header sits in normal flow (the search is pulled
          out via `position: absolute`), so this is the one child that needs pushing to
          the far edge. */}
      <div className="shell-header-right">
        <HeaderActions />
        <span className="shell-header-divider" aria-hidden />
        <UserMenu />
      </div>
      <MainSideNav expanded={expanded} />
    </Header>
  );
};

export default MainHeader;
